import { filter } from 'rxjs';
import { Component, ViewChild, Input, ElementRef, HostListener, TemplateRef } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { PatientService } from '../../services/patient.service';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { merge, startWith, switchMap, catchError, map } from 'rxjs';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { UploadService } from 'src/app/private/services/upload.service';
import { AppointmentService } from 'src/app/private/services/appointment.service';

@Component({
  selector: 'app-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.scss']
})
export class PatientsComponent {
   @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    isMobileView = window.innerWidth <= 1024;
    scrollThumbWidth = 10;
    scrollThumbLeft = 0;
    initialLoad: boolean = true;
  isDataLoading: boolean = true;
  @ViewChild('addPatientWindow') addPatientWindow!: TemplateRef<any>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  private addModalRef: NgbModalRef | null = null;
  private importModalRef: NgbModalRef | null = null;
  @Input() patient: any;
  newPatient: any = {
    "pId": "N/A",
    "hospital_id": null,
    "center_id": null,
    "prefix": null,
    "photo": null,
    "fname": null,
    "lname": null,
    "name": null,
    "gender": null,
    "age": null,
    "months": null,
    "dob": null,
    "blood_group": null,
    "uid_number": null,
    "abha_number": null,
    "alt_contact_number": null,
    "old_patient_record_number": null,
    "insurance_details": null,
    "mobile": null,
    "email": null,
    "address": null,
    "source": "webapp",
  }
  imgUpload: boolean = false;
  btnUpdate: boolean = false;
  btnImport: boolean = false;
  imgTitle: any = "Upload Image"
  file: any;
  url: any = 'assets/img/no-image.jpg';
  editMode: boolean = false;
  isLoading = false;
  btnLoading = false;
  topBarTitle: string = "Patients";
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  appointment: Appointment = new Appointment();
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  isSubmittedresCheduled: boolean = false;
  dateQuery = new FormControl();
  formAction = "add";
  closeResult = '';
  DateList: any = [];
  TimeList: any = [];
  current_id_hover: any;
  paymentDetail: any = {
    payment_status: "",
    remarks: "",
    service: "",
    pincode: "",
  }
  @ViewChild("reappointmentForm")
  reappointmentForm!: NgForm;
  isSubmitted: boolean = false;
  exportArrayData: any = [];
  isOnlinePayment: boolean = false;
  displayedColumns: string[] = ["pId", "name", "gender", "age", "dob", "blood_group", "mobile", "email", "action"];
  exportColumns: any = [];
  topPosition: any;
  leftPosition: any;
  hoveredRow: any;
  departmentListDp: any = []
  DoctorDpList: any = []
  selectedItem: any;
  filtersObject: any = {};
  timeZone: any = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Calcutta";
  app_count: any = {
    all: null,
    today: null,
    tomorrow: null,
    week: null,
    month: null
  }
  selected_tab: any = "all";

  displayedColumn: string[] = ["pId", "name", "gender", "age", "dob", "blood_group", "mobile", "email", "action"];
  dataSources = new MatTableDataSource<any>([]);
  maxRecords = 500; // Set max record limit

  @ViewChild(MatPaginator) paginators!: MatPaginator;


  constructor(private uploadService: UploadService, private router: Router, private toast: ToastrService, private api: PatientService, private modalService: NgbModal, private localStorage: LocalStorageService) {

  }
  ngAfterViewInit() {
    this.dataSources.paginator = this.paginators;
    this.loadData();
    
    // Check if there is extracted patient data from OCR to pre-fill
    setTimeout(() => {
      const ocrDataStr = localStorage.getItem('ocr_patient_data');
      if (ocrDataStr) {
        try {
          const ocrData = JSON.parse(ocrDataStr);
          this.newPatient = {
            ...this.newPatient,
            ...ocrData
          };
          if (this.addPatientWindow) {
            this.open(this.addPatientWindow);
          }
        } catch (e) {
          console.error('Error parsing OCR patient data:', e);
        } finally {
          localStorage.removeItem('ocr_patient_data');
        }
      }
    }, 100);
  }

  formatTo12Hour(time: string): string {
    if (this.localStorage.isTwelveHourFormat()) {
      return moment(time, 'HH:mm').format('hh:mm A');
    }
    else {
      return time;
    }
  }

  showInfo(row: any, event: any) {
    this.hoveredRow = row;
    this.topPosition = event.clientY;
    this.leftPosition = event.clientX;
    this.current_id_hover = row.appointment.app_id
  }
  onMouseMove(row: any, event: MouseEvent): void {
    this.current_id_hover = row.appointment.app_id;
  }
  openDialog(element: any) {

  }
  hideInfo() {
    this.current_id_hover = "";
  }

  // load Initial table data from based on source type
  loadData() {
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(this.dateQuery.valueChanges, this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page).pipe(startWith({}),
        switchMap(() => {
          this.isDataLoading = true;
          console.log("search val : ", this.searchQuery.value)
          let param = {
            where: { hospital_id: this.localStorage.getHospitalId(), center_id: this.localStorage.getCenterId() },
            filter: this.searchQuery.value,
            custom_filter:this.filtersObject,
            page: (this.paginator.pageIndex * this.paginator.pageSize),
            limit: this.paginator.pageSize,
            order: [["id", "DESC"]]
          }
          if (this.dateQuery.value) { param = { ...param, ...this.dateQuery.value } }
          // Patients belong to the hospital and center globally; do not filter patient listing by creator's user_id
          param = param;
          //console.log(this.localStorage.getRole())
          return this.api.getAllPatientWithCount(param)
            .pipe(catchError(() => observableOf(null)));
        }), map((response: any) => {
          this.initialLoad = false;
          if (response === null) {
            return [];
          }
          if (this.selected_tab == 'all') {

            this.app_count = {
              all: response.count,
              today: null,
              tomorrow: null,
              week: null,
              month: null
            }
          }
          this.totalRows = response.count;
          return response
        })
      ).subscribe({
        next: (data) => {
          // console.log(data)
          this.initialLoad = false;
            this.isDataLoading = false;
          this.exportArrayData = data.rows;
          this.dataSource = new MatTableDataSource<any>(data.rows);
          this.exportColumns = ["PId", "Prefix", "First Name", "Last Name", "Gender", "Age", "DOB", "Mobile", "Email", "Address", "Blood Group", "Abha Number", "UID" ];
        },
        error: (e) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          console.error(e)
        },
        complete: () => {
          this.initialLoad = false;
        }
      })
    }
    catch (e) {
      this.initialLoad = false;
      console.error(e)
    }
  }
  searchFilter(query: any) {

    // alert(query)
    this.searchQuery.setValue(query);
  }

  loadAppointmentByTab(type: any) {
    this.selected_tab = 'all'
  }

  open(content: any) {
    this.addModalRef = this.modalService.open(content, { 
      windowClass: 'modern-patient-modal', 
      scrollable: false,
      centered: true
    });
  }

  importData(content: any) {
    this.importModalRef = this.modalService.open(content, { 
      size: 'xl', 
      scrollable: false,
      modalDialogClass: 'full-screen-modal-patient' // Add custom class
    });
    

  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  viewPatientfn(content: any, item: any) {
    // this.selectedItem = item;
    this.patient = item
    this.modalService.open(content, { 
      windowClass: 'modern-patient-modal', 
      scrollable: false, 
      ariaLabelledBy: 'modal-basic-title', 
      centered: true 
    }).result.then((result) => {
      if (result === 'yes') {

      }
    }, (reason) => {

    });
  }

  toNormalCapitalization(text: any) {
    return text.toLowerCase().replace(/(?:^|\s)\S/g, function (a: any) { return a.toUpperCase(); });
  }

  onFileChange(args: any) {
    const target: DataTransfer = <DataTransfer>(args.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      //console.log(data); // Data will be logged in array format containing objects
    };
  }
  export(header: any) {
    //console.log(header)
    console.log("exportArrayData : ", this.exportArrayData);
    let excelRowData: any = [];
    this.exportArrayData.forEach((element: any) => {
      excelRowData.push({ 0: element.pId, 1: element.prefix, 2: element.fname,3: element.lname, 4: element.gender, 5: element.age, 6: element.dob, 7: element.mobile, 8: element.email, 9: element.address, 10: element.blood_group, 11: element.abha_number, 12: element.uid_number})
    });

    let excelData = [];
    let excelHeader = [];
    for (let i = 0; i < excelRowData.length; i++) {
      let element = excelRowData[i];
      let obj: any = {}
      for (let index = 0; index < header.length; index++) {
        let key = header[index]['key'];
        obj[key] = element[key]
      }
      excelData.push(obj)
    }
    for (let index = 0; index < header.length; index++) {
      let value = header[index]['value'];
      excelHeader.push(value)
    }
    //console.log(excelData)
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, [excelHeader]);
    XLSX.utils.sheet_add_json(ws, excelData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    XLSX.writeFile(wb, "Patients_data_" + day + "_" + month + "_" + year + "_" + date.getTime() + ".csv");
  }

  apptnotes: any = {};
  remarkNote = "";
  reasonNote = "";
  selectedRow: any = null;

  clearNote() {
    this.apptnotes = [];
    this.remarkNote = "";
    this.reasonNote = "";
  }

  addPatient(content: any) {
    this.patient = []
    this.modalService.open(content, { windowClass: 'modal modal-huge', scrollable: false, ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      console.log("result : ", result)
      // if (result === 'yes') {  
      //   console.log("result : ",result)
      //   // let param = {
      //   //   patient_id:item.appointment.patient_id,
      //   //   app_id:item.appointment.app_id,
      //   //   hospital_id:this.localStorage.getHospitalId(),
      //   //   status:"no-show",
      //   // }
      //   // this.api.updateAppointment(param).subscribe({
      //   //   next:(res)=>{
      //   //     this.modalService.dismissAll();
      //   //     this.toast.success("Appointment Updated Successfully")
      //   //     this.loadData()
      //   //   },

      //   //   error:(e)=>{

      // }
      //   })
      // }  
      // }, (reason) => {  

    });
  }

  testy() {
    if (this.remarkNote) {
      let now = new Date();
      let date = new Intl.DateTimeFormat('en-GB').format(now).replace(/\//g, '-'); // e.g., "11/27/2024"
      let time = now.toLocaleTimeString(); // e.g., "10:15:30 AM"
      let note = {
        "remark": this.remarkNote,
        "reason": this.reasonNote,
        "date": date,
        "time": time
      }
      this.selectedRow.appointment.apptRemarks.push(note);
      console.log()

      // const data = this.dataSource.data;

      // // Find and update the selected row directly
      // const rowToUpdate = data.find((item) => item.id === this.selectedRow.id);
      // if (rowToUpdate) {
      //   Object.assign(rowToUpdate, this.selectedRow); // Update only the changed fields
      // }

      // // Refresh the table (optional if Angular detects changes automatically)
      // this.dataSource.data = data;

      console.log("this.apptnotes : ", this.apptnotes);
      this.apptnotes.push(note)
      console.log("new note : ", note);
    }
  }
  actionButton = "search"
  SearchInput = "";

  customSearchFilter(event: any) {
    this.filtersObject = event;
    this.loadData();
  }
  dateFilter(event: any) {
    //alert(event)
    this.dateQuery.setValue(event)
  }

  showFilterData(event: any) {
    if (event) {

    }
  }

  calculateAge() {
    const target = (this.patient && this.patient.dob) ? this.patient : this.newPatient;
    if (target && target.dob) {
      const today = new Date();
      const birthDate = new Date(target.dob);
      let age: any = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      console.log("months : ", monthDiff);
      target.months = String(monthDiff);
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      target.age = age;
    }
  }

  calculateDOB() {
    const target = (this.patient && this.patient.age !== null && this.patient.age !== undefined) ? this.patient : this.newPatient;
    if (target && target.age !== null && target.age !== undefined) {
      let age: any = target.age;
      const today = new Date();
      const birthYear = today.getFullYear() - age;
      const birthMonth = today.getMonth();
      const birthDay = today.getDate();
      target.dob = new Date(birthYear, birthMonth, birthDay).toISOString().split('T')[0];
    }
  }

  onFileSelected(event: any, isNew: boolean = false) {

    const files = event.target.files;
    if (files.length === 0)
      return;

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.toast.error('Only images are supported.');
      return;
    }

    const reader = new FileReader();
    this.file = files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      if (isNew) {
        this.newPatient.photo = reader.result;
      } else {
        this.patient.photo = reader.result;
      }
      //  this.updateData();
    }

  }

  uploadImage() {

    if (this.file) {
      console.log(this.file)
      this.imgUpload = true;
      this.imgTitle = "Uploading.."
      let name = this.file.name;
      const formData = new FormData();
      formData.append("file", this.file, this.patient.pId);
      let folder = "public/hospital-" + this.localStorage.getHospitalId() + "/" + this.patient.pId + "/profile"
      formData.append("folders", folder);
      formData.append("bucket", "emruploads");
      console.log(formData)
      this.uploadService.uploadPatientProfile(formData).subscribe({
        next: (res) => {
          console.log(res)
          if (res) {


            let param = {
              id: this.patient.id,
              hospital_id: this.patient.hospital_id,
              center_id: this.patient.center_id,
              photo: res.url

            }
            this.patient.photo = res.url;
            this.file = "";
            this.api.updatePatient(param).subscribe({
              next: (res: any) => {
                if (res) {
                  this.imgUpload = false;

                  this.toast.success("Profile Uploaded Successfully")
                }
              }
            })
            this.imgTitle = "Upload Image"
          }
        },
        error: (e) => {
          this.imgTitle = "Upload Image"
        }
      })
    }
  }

  updateData() {
    this.btnUpdate = true
    this.api.updatePatient(this.patient).subscribe({
      next: (res: any) => {
        if (res) {
          this.btnUpdate = false;
          this.toast.success("Profile Updated Successfully")
        }
      },
      error: (e) => {
        this.btnUpdate = false
      }
    })
  }

  changeEditMode() {
    this.editMode = !this.editMode;
  }

  addData() {
    this.btnUpdate = true;
    this.newPatient.name = (this.newPatient.fname || "").trim() + " " + (this.newPatient.lname || "").trim();
    this.newPatient.hospital_id = this.localStorage.getHospitalId();
    this.newPatient.center_id = this.localStorage.getCenterId();
    
    // Assign a unique dummy mobile number starting with "00" if blank to bypass backend findOrCreate uniqueness checks
    if (!this.newPatient.mobile || !this.newPatient.mobile.trim()) {
      this.newPatient.mobile = "00" + Date.now().toString().slice(-6) + Math.floor(Math.random() * 100).toString().padStart(2, '0');
    }
    
    // Assign dummy email if blank
    if (!this.newPatient.email || !this.newPatient.email.trim()) {
      this.newPatient.email = "N/A";
    }

    if (!this.newPatient.prefix) {
      this.newPatient.prefix = "Mr";
    }

    this.api.createPatient(this.newPatient).subscribe({
      next: (res: any) => {
        if (res) {
          this.btnUpdate = false;
          Object.keys(this.newPatient).forEach(key => this.newPatient [key] = "");
          this.addModalRef?.close();
          this.toast.success("Profile created Successfully");
          this.loadData();
        }
      },
      error: (e) => {
        this.btnUpdate = false
        this.toast.error("Profile creation Failed")
      }
    })
  }


  onFileCnhosen(event: any): void {
      const file: File = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = () => {
          const csvData = reader.result as string;
          this.parseCSV(csvData);
        };
      }
    }
  
    tableData :any = [];

    parseCSV(csvData: string): void {
      const rows = csvData.split('\n').map(row => row.trim()).filter(row => row);
      const csvHeaders = rows[0].split(',').map(header => header.trim());
    
      this.tableData = rows.slice(1).map((row, index) => {
        const values = row.split(',').map(value => value.trim());

        let mobileVal = values[csvHeaders.indexOf("Mobile")] || null;
        if (!mobileVal || mobileVal.trim() === '') {
          // Generate a unique number using timestamp + loop index + padding
          mobileVal = "00" + Date.now().toString().slice(-5) + String(index).padStart(3, '0');
        }

        let emailVal = values[csvHeaders.indexOf("Email")] || null;
        if (!emailVal || emailVal.trim() === '') {
          emailVal = "N/A";
        }
    
        let newPatient = {
          pId: "N/A",
          prefix: null,
          photo: null,
          fname: values[csvHeaders.indexOf("First Name")] || "",
          lname: values[csvHeaders.indexOf("Last Name")] || "",
          name: values[csvHeaders.indexOf("First Name")] || "" + " " +values[csvHeaders.indexOf("Last Name")] || "",
          gender: values[csvHeaders.indexOf("Gender")] || null,
          age: values[csvHeaders.indexOf("Age")] || null,
          dob: values[csvHeaders.indexOf("DOB")] || null,
          blood_group: values[csvHeaders.indexOf("Blood Group")] || null,
          uid_number: values[csvHeaders.indexOf("UID")] || null,
          abha_number: values[csvHeaders.indexOf("Abha Number")] || null,
          alt_contact_number: null,
          old_patient_record_number: null,
          insurance_details: null,
          mobile: mobileVal,
          email: emailVal,
          address: values[csvHeaders.indexOf("Address")] || null,
          hospital_id: this.localStorage.getHospitalId(),
          center_id: this.localStorage.getCenterId(),
          custodian: null
        };
    
        // Set full name
        newPatient.name = (newPatient.fname || "") + " " + (newPatient.lname || "");
    
        return newPatient;
      });
  
      if (rows.length - 1 > this.maxRecords) {
        alert(`CSV file has more than ${this.maxRecords} records! Only ${this.maxRecords} records allowed.`);
        this.dataSources.data = [];  // Clear table data
        return;
      }
      console.log("dataaaaa : ",this.tableData);
      this.dataSources.data = this.tableData;
    }

    setPageSize(size: number) {
      console.log("ssssttyy : ",size)
      console.log("2333333 : ",this.paginators)
      if (this.paginators) {
        this.paginators.pageSize = size;
        this.paginators.firstPage(); // Reset to first page
        this.dataSources.paginator = this.paginators;
      }
    }

    addImportData() {
      this.btnImport = true
      let param = {
          "patients": this.tableData
      }
      this.api.createPatientsBatch(param).subscribe({
        next: (res: any) => {
          if (res) {
            this.btnImport = false;
            this.importModalRef?.close();
            this.toast.success("records created Successfully");
            this.loadData();
            this.tableData = [];
            this.dataSources.data = []; 
          }
        },
        error: (e) => {
          this.btnImport = false
          this.importModalRef?.close();
          this.toast.error("record creation Failed")
        }
      })
    }

    clearImportData() {
      this.tableData = [];
      this.dataSources.data = []; 
    }

    downloadEmptyCSV() {
      const columns = [
        "PId", "Prefix", "First Name", "Last Name", "Gender", "Age", "DOB", 
        "Mobile", "Email", "Address", "Blood Group", "Abha Number", "UID"
      ];
    
      // Convert array to CSV format (header row only)
      const csvContent = columns.join(",") + "\n";
    
      // Create a Blob and a downloadable link
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "patients_data.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }

@HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth <= 1024;
  }

handleScrollLeft() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: -150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

handleScrollRight() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: 150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

updateScrollThumb() {
  if (!this.scrollContainer) return;

  const container = this.scrollContainer.nativeElement;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;
  const scrollLeft = container.scrollLeft;

  if (scrollWidth > clientWidth) {
    this.scrollThumbWidth = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
    const maxScrollLeft = scrollWidth - clientWidth;
    const scrollPercentage = (scrollLeft / maxScrollLeft) * 100;
    this.scrollThumbLeft = (scrollPercentage * (100 - this.scrollThumbWidth)) / 100;
    this.scrollThumbLeft = Math.max(0, Math.min(100 - this.scrollThumbWidth, this.scrollThumbLeft));
  } else {
    this.scrollThumbWidth = 100;
    this.scrollThumbLeft = 0;
  }
}

goToOcrChat(patient: any) {
  if (patient && patient.pId) {
    localStorage.setItem('ocr_chat_session_id', patient.pId);
  }
  this.router.navigate(['/main/ai-ocr/document-chat']);
}

goToOcrHub(patient: any) {
  if (patient && patient.pId) {
    localStorage.setItem('ocr_chat_session_id', patient.pId);
  }
  this.router.navigate(['/main/ai-ocr']);
}

}


function observableOf(arg0: null): any {
  //throw new Error('Function not :mplemented.');
}



export class Appointment {
  app_id!: Number;
  user!: any;
  appointment_source: string = "webapp";
  appointment_type: string = "";
  appointment_date: string = "";
  appointment_time: string = "";
  status: string = "booked";
  user_id: string = "";
  patient_id: Number = 0;
  dept_id: string = "";
  client_id: string = ""
  check_in_type: string = "follow-up";
  opd_number: string = ""
  hospital_id: Number = 0
  center_id: Number = 0
}